
export { TooltipIcon } from "./TooltipIcon"